module.exports = __webpack_public_path__ + "src/img/up.6bde3de3.svg";